import { getApiEnvironment } from '~/utils/common'

interface ApiDomains {
  MANGO_API: string
  CHAT_RTM: string
}

interface ApiDomainsAccessor {
  JWT_AUTH: () => string
  MANGO_API: () => string
  CHAT_RTM: () => string
}

export const stagingDomains: ApiDomains = {
  MANGO_API: 'https://api-staging.mangovoice.com',
  CHAT_RTM: 'wss://wss-staging.mangovoice.com:4000',
}

export const productionDomains: ApiDomains = {
  MANGO_API: 'https://api.mangovoice.com',
  CHAT_RTM: 'wss://wss.mangovoice.com:4000',
}

const api_env = getApiEnvironment()
const getDomain = (domain: string) => {
  if (api_env === 'staging') {
    return stagingDomains[domain]
  }

  return productionDomains[domain]
}

export const domains: ApiDomainsAccessor = {
  JWT_AUTH: () => getDomain('JWT_AUTH'),
  MANGO_API: () => getDomain('MANGO_API'),
  CHAT_RTM: () => getDomain('CHAT_RTM'),
}
